
/**
@element com-adaptive
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import { afterNextRender } from '@polymer/polymer/lib/utils/render-status.js';

import '@polymer/iron-media-query/iron-media-query.js';

import { COMThrottleBehavior } from '@com/throttle';

export const COMAdaptiveBehavior = function(superClass) {

  return class extends COMThrottleBehavior(superClass) {

    static get properties() {
      return {

        /**
         * @desc Allow custom breakpoints
         * @type {Boolean}
         */
        allowCustomBreakpoints: {
          type: Boolean,
          value: false
        },

        /**
         * @desc xs min custom breakpoint
         * @type {Number}
         */
        xsMin: {
          type: Number,
          value: 375
        },

        /**
         * @desc sm min custom breakpoint
         * @type {Number}
         */
        smMin: {
          type: Number,
          value: 768
        },

        /**
         * @desc md min custom breakpoint
         * @type {Number}
         */
        mdMin: {
          type: Number,
          value: 970
        },

        /**
         * @desc lg min custom breakpoint
         * @type {Number}
         */
        lgMin: {
          type: Number,
          value: 1170
        },

        queries: {
          type: Array,
          value: function() {
            // min sizes
            var xsMin = 375, // covers iphone 6 and iphone 6 plus
              smMin = 768, // covers ipad portrait
              mdMin = 970, // covers desktop
              lgMin = 1170; // covers large desktop

            // max sizes
            var xsMax = smMin - 1,
              smMax = mdMin - 1,
              mdMax = lgMin - 1;

            // force desktop view if pep is in desktop mode DLT-3701
            // -- allowResponsive to disable forcing desktop view
            let queryItems = [
                {
                  property: 'xs',
                  query: '(max-width: ' + xsMax + 'px)'
                }, {
                  property: 'sm',
                  query: '(min-width: ' + smMin + 'px) and (max-width: ' + smMax + 'px)'
                }, {
                  property: 'md',
                  query: '(min-width: ' + mdMin + 'px) and (max-width: ' + mdMax + 'px)'
                }, {
                  property: 'lg',
                  query: '(min-width: ' + lgMin + 'px)'
                }
              ];

            return queryItems.map(function(item) {
              var mq = document.createElement('iron-media-query');
              mq.query = item.query;
              mq.property = item.property;
              return mq;
            });
          }
        },
        adaptive: {
          type: String,
          reflectToAttribute: true
        }
      };
    }

    ready() {
      super.ready();
      this._updateElements();
      if (this._isNavigatorSafari()) {
        this._forceRepaint();
        /* add listeners */
        let forceRepaint = this.throttle(() => this._forceRepaint());
        window.addEventListener('resize', forceRepaint);
        afterNextRender(this, forceRepaint);
      }
    }

    /**
     * @desc Get query items using custom breakpoints
     * @return {Object}
     */
    _getQueries() {
      // min sizes
      let xsMin = this.xsMin; // covers iphone 6 and iphone 6 plus
      let smMin = this.smMin; // covers ipad portrait
      let mdMin = this.mdMin; // covers desktop
      let lgMin = this.lgMin; // covers large desktop

      // max sizes
      let xsMax = smMin - 1;
      let smMax = mdMin - 1;
      let mdMax = lgMin - 1;

      let queryItems = [
          {
            property: 'xs',
            query: '(max-width: ' + xsMax + 'px)'
          }, {
            property: 'sm',
            query: '(min-width: ' + smMin + 'px) and (max-width: ' + smMax + 'px)'
          }, {
            property: 'md',
            query: '(min-width: ' + mdMin + 'px) and (max-width: ' + mdMax + 'px)'
          }, {
            property: 'lg',
            query: '(min-width: ' + lgMin + 'px)'
          }
        ];

      return queryItems.map(function(item) {
        var mq = document.createElement('iron-media-query');
        mq.query = item.query;
        mq.property = item.property;
        return mq;
      });
    }
    /**
     * @desc update element query property
     * @return {Void}
     */
    _updateElements() {
      let element = this;
      let queries = element.allowCustomBreakpoints ? this._getQueries() : element.queries;

      queries.forEach(function(query) {
        // set initial adaptive property value.
        if (query.queryMatches) {
          element.adaptive = query.property;
        }

        // update adaptive property when matching query changes
        query.addEventListener('query-matches-changed', function(event) {
          if (event.detail.value) {
            element.adaptive = query.property;
          }
        });
        if (!element.shadowRoot) {
          element.attachShadow({ mode: 'open'});
        }
        element.shadowRoot.appendChild(query);
      });
    }

    /**
     * @desc safari check
     * @return {Boolean}
     */
    _isNavigatorSafari() {
      /* Uses negative look-arounds and to excludes Chrome, Edge,
        * and all Android browsers that include the Safari name in their user agent.
        * @see: https://stackoverflow.com/questions/7944460/detect-safari-browser
        */
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && this.root;
    }

    /**
     * @desc Repaint Hack
     * @see https://github.com/Polymer/polymer/issues/4695
     * @see https://bugs.webkit.org/show_bug.cgi?id=170762
     * @return {Boolean}
     */
    _forceRepaint() {
      this.shadowRoot.querySelectorAll('*').forEach((el) => {
        el.style['-webkit-backface-visibility'] = 'visible';
        el.style['-webkit-backface-visibility'] = '';
      });
    }
  }
};

class COMAdaptive extends COMAdaptiveBehavior(PolymerElement) {
  static get is() { return 'com-adaptive'; }
  static get properties() {
    return {
      /**
       * @desc adaptive property provided by adaptive behavior
       * @type String
       */
      adaptive: {
        type: String,
        notify: true
      }
    };
  }
}
customElements.define(COMAdaptive.is, COMAdaptive);

